import React, { useMemo, useState } from 'react';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useAccount, useDisconnect } from 'wagmi';
import { httpEnsApi } from '../../../adapters/ens/httpEnsApi';
import { wagmiEnsWallet } from '../../../adapters/wallet/wagmiAdapters';
import { currentDemo, Demo } from '../../../adapters/demo/demo';
import { demoEnsApi, demoWallet } from '../../../adapters/demo/fakes';
import { EnsScreen } from './EnsScreen';

/** Composition root of /ens: the real API and wallet, or the local demo fakes on this machine. */

const LiveEns: React.FC = () => {
  const { address } = useAccount();
  const { openConnectModal } = useConnectModal();
  const { disconnect } = useDisconnect();
  const ports = useMemo(
    () => ({ api: httpEnsApi, wallet: wagmiEnsWallet(address ?? null), connect: () => openConnectModal?.(), disconnect: () => disconnect() }),
    [address, openConnectModal, disconnect]
  );
  return <EnsScreen ports={ports} />;
};

const DemoEns: React.FC<{ demo: Demo }> = ({ demo }) => {
  const [on, setOn] = useState(demo !== 'off');
  const api = useMemo(() => demoEnsApi(demo), [demo]);
  const ports = useMemo(
    () => ({ api, wallet: demoWallet(on ? (demo === 'off' ? 'on' : demo) : 'off'), connect: () => setOn(true), disconnect: () => setOn(false) }),
    [api, demo, on]
  );
  return <EnsScreen ports={ports} />;
};

const EnsPage: React.FC = () => {
  const demo = currentDemo();
  return demo ? <DemoEns demo={demo} /> : <LiveEns />;
};

export default EnsPage;
